<div class="field">
  <div class="lines">
    <div class="half-circle"></div>
    <div class="gate"></div>
  </div>
  <ng-content></ng-content>
</div>
